import { useEffect, useState } from 'react';
import { IUseMicrophoneTestProps, RenderFrameType } from './interfaces';

export const useMicrophoneTest = ({
  activeDeviceId,
  permissionState,
}: IUseMicrophoneTestProps) => {
  const [volume, setVolume] = useState(0);

  useEffect(() => {
    const timeoutIDs: ReturnType<typeof setInterval>[] = [];
    let unmuted = false;

    const setMicrophoneValue: RenderFrameType = ({
      analyser,
      bufferLength,
    }) => {
      const dataArray = new Uint8Array(bufferLength);

      requestAnimationFrame(() => {
        if (unmuted) {
          return;
        }

        setMicrophoneValue({ analyser, bufferLength });
      });

      analyser.getByteFrequencyData(dataArray);

      for (let i = 0; i < bufferLength; i++) {
        const timeoutID = setTimeout(() => {
          if (unmuted) {
            return;
          }

          // Compute the average volume from the frequency data
          const avg = dataArray.reduce((a, b) => a + b, 0) / dataArray.length;

          // Scale the volume
          setVolume(Math.round(avg));
        }, 10);

        timeoutIDs.push(timeoutID);
      }
    };

    const startCheckMicro = async () => {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        audio: { deviceId: { exact: activeDeviceId }, noiseSuppression: true },
        video: false,
      });

      const audioContext = new AudioContext({ sampleRate: 44100 }); // To be compatible with more devices
      const src = audioContext.createMediaStreamSource(mediaStream);
      const analyser = audioContext.createAnalyser();

      src.connect(analyser);
      analyser.fftSize = 256;

      const bufferLength = analyser.frequencyBinCount;

      setMicrophoneValue({ analyser, bufferLength });
    };

    if (permissionState === 'granted') {
      startCheckMicro();
    }

    return () => {
      unmuted = true;

      setTimeout(() => {
        timeoutIDs.map((timeoutID) => clearTimeout(timeoutID));
      }, 0);
    };
  }, [activeDeviceId, permissionState]);

  return { volume };
};
